<template>
  <div class="main-page-manage-events-view-manager">
    <div class="events-found marginLeft24px">{{ getTotal || 0 }}{{textPlus}} EVENTS FOUND</div>
    <div class="list-event-manage-by-date-container">
      <div v-for="(item, index) in getEvents">
        <div class="cheetah-digital marginLeft24px"><span>{{ item.clientName }}</span></div>
        <div class="event-cards-wrapper">
          <EventCard :key="index" :event="event" v-for="(event, index) in item.events" :isNoTrans="index % 3 == 2"></EventCard>
        </div>
        <div class="clear-both"></div>
      </div>
      <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading" :distance="100" >
        <Spinner slot="spinner"></Spinner>
        <div slot="no-more" class="infinite-status-prompt"></div>
        <div slot="no-results" class="infinite-status-prompt"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
  import consts from '../../../_consts';
  import EventCard from './EventCard'
  /* Register component with one of 2 methods */
  import 'vue-awesome/icons/spinner';
  import Icon from 'vue-awesome/components/Icon';
  import InfiniteLoading from 'vue-infinite-loading';
  import Spinner from '@/components/commons/Spinner';
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  export default {
    name: 'manage-view',
    components: {
      EventCard,
      Icon,
      InfiniteLoading,
      Spinner
    },
    methods: {
      infiniteHandler ($state) {
        let vm = this;
        let params = {
          changeFilter: this.changeFilter
        };
        this.getData(params)
          .then((res) => {
            this.changeFilter = false;
            if (res && vm.pagingObj.currentPage * vm.pagingObj.itemsPerPage > vm.getTotal) {
              $state.complete();
              this.textPlus = '';
            } else {
              this.textPlus = '+';
              $state.loaded();
            }
            vm.pagingObj.currentPage++;
          });
      },
      getData (params) {
        let vm = this;
        return new Promise((resolve, reject) => {
          let body = {
            // set limit Begin date range
            noBeginDates: vm.dateOut[0],
            noEndDates: vm.dateOut[1],
            selectedDate: null,
            clientId: localStorage.getItem(consts.LOCAL_STORE.clientId),
            keyword: this.textSearch,
            currentPage: vm.pagingObj.currentPage,
            itemsPerPage: vm.pagingObj.itemsPerPage,
            sortType: vm.sortBy[0],
            status: vm.filterBy[0],
            ...params
          };
          vm.getEventsByDates(body).then(response => {
            if (vm.pagingObj.currentPage * vm.pagingObj.itemsPerPage > vm.getTotal) {
              this.textPlus = '';
            } else {
              this.textPlus = '+';
            }
            resolve(response);
          });
        });
      },
      resetPagingOption () {
        this.pagingObj.currentPage = 1;
        this.pagingObj.itemsPerPage = 10;
      },
      ...mapActions({
        getEventsByDates: 'ACTION_GET_EVENTS_BY_DATES'
      }),
      ...mapMutations({
        setListEventApproved: 'MUTATION_SET_APPROVED_EVENTS'
      })
    },
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      dateOut: {
        type: Array,
        default: () => ['0', '60+']
      },
      filterBy: {
        type: Array,
        default: () => ['APPROVED']
      },
      sortBy: {
        type: Array,
        default: () => ['dateTime']
      },
      textSearch: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapGetters({
        getEvents: 'GETTERS_EVENTS_BY_DATES',
        getTotal: 'GETTERS_TOTAL_EVENTS'
      })
    },
    data () {
      return {
        pagingObj: {
          currentPage: 1,
          itemsPerPage: 10
        },
        textPlus: '',
        changeFilter: false
      }
    },
    created () {
      // this.getData();
      this.setListEventApproved({changeFilter: true, approvedEvents: []});
    },
    mounted () {
      if (this.$route.params && this.$route.params.eventId) {
        let params = {
          eventId: this.$route.params.eventId,
          isChangeOrder: this.isChangeOrder
        };
        this.$modal.show('eventDetailModal', params);
      }
    },
    watch: {
      textSearch: {
        handler: function (val, oldVal) {
          this.changeFilter = true;
          this.resetPagingOption();
          this.$refs.infiniteLoading.stateChanger.reset();
          let params = {
            changeFilter: true
          };
          this.getData(params);
        }
      },
      dateOut: {
        handler: function (val, oldVal) {
          if (val[0] === oldVal[0] && val[1] === oldVal[1]) {
            return;
          }
          this.changeFilter = true;
          this.resetPagingOption();
          this.$refs.infiniteLoading.stateChanger.reset();
          let params = {
            changeFilter: true
          };
          this.getData(params);
        },
        deep: true
      },
      sortBy: {
        handler: function (val, oldVal) {
          if (val[0] === oldVal[0]) {
            return;
          }
          this.changeFilter = true;
          this.resetPagingOption();
          this.$refs.infiniteLoading.stateChanger.reset();
          let params = {
            changeFilter: true
          };
          this.getData(params);
        },
        deep: true
      },
      filterBy: {
        handler: function (val, oldVal) {
          if (val[0] === oldVal[0]) {
            return;
          }
          this.changeFilter = true;
          this.resetPagingOption();
          this.$refs.infiniteLoading.stateChanger.reset();
          let params = {
            changeFilter: true
          };
          this.getData(params);
        },
        deep: true
      }
    }
  };
</script>
<style scoped lang="less">
  .main-page-manage-events-view-manager{
    padding: 24px;
    height: calc(~"100vh - 280px");
    overflow-y: auto;

    .list-event-manage-by-date-container{
      height: 100%;
      max-width: 100%;
    }
  }
  .events-found {
    height: 16px;
    width: 120px;
    color: #8E8E8E;
    font-family: "Open Sans", serif;
    font-size: 12px;
    letter-spacing: 0.1px;
    line-height: 16px;
    margin-bottom: 22px;
  }
  .cheetah-digital {
    height: 16px;
    color: #626262;
    font-family: "Open Sans", serif;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 16px;
    max-width: 290px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .event-cards-wrapper {
    margin: 0 -12px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    .event-card-container{
      margin: 12px;
    }
  }
  .isLoading {
     display: block;
     text-align: center;
     color: #606060;
   }
  .noDisplay {
    display: none;
  }
  .overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 999;
    cursor: pointer;
  }
  .text{
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 50px;
    color: white;
    transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
  }
</style>



// WEBPACK FOOTER //
// Manage.vue?afcbcaa2